import CssLayers from "../CssLayers";
import PlusIcon from "../icons/PlusIcon";
import PropTypes from "prop-types";
import React from "react";

export default function SideContentCircle({ size, color, hoverColor, top, left, visible, css, innerRef, ...props }) {
  return (
    <div
      {...props}
      ref={innerRef}
      css={{
        ...css,

        width: size,
        height: size,

        borderRadius: "100%",
        position: "absolute",
        visibility: visible ? "visible" : "hidden",
        zIndex: CssLayers.SIDE_CONTENT_CIRCLE,

        boxSizing: "border-box",
        border: `2px solid ${color}`,
        color,
        fontSize: 14,
        fontWeight: "bold",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        cursor: "pointer",

        userSelect: "none",

        padding: 3,

        "&:hover": {
          borderColor: hoverColor,
          color: hoverColor,
        },
      }}
      style={{
        top,
        left: (size + left) * -1,
      }}
    >
      <PlusIcon />
    </div>
  );
}

SideContentCircle.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  hoverColor: PropTypes.string.isRequired,
  top: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  visible: PropTypes.bool.isRequired,
  css: PropTypes.object,
};

SideContentCircle.defaultProps = {
  css: {},
};
